var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M698.283,415.351h-.762v-3.91a.762.762,0,0,0-.762-.762H686.1a.762.762,0,0,0-.762.762v3.91h-1.654a2.289,2.289,0,0,0-2.155-1.524H679.9a2.288,2.288,0,0,0-2.155,1.524h-.892a2.288,2.288,0,0,0-2.285,2.285V432.87a2.288,2.288,0,0,0,2.285,2.285h.892a2.286,2.286,0,0,0,2.155,1.524h1.625a2.288,2.288,0,0,0,2.155-1.523h14.6a2.288,2.288,0,0,0,2.285-2.286V417.636A2.289,2.289,0,0,0,698.283,415.351Zm-20.668,18.281h-.762a.762.762,0,0,1-.762-.762V417.636a.762.762,0,0,1,.762-.762h.762Zm4.672.762a.762.762,0,0,1-.762.762H679.9a.762.762,0,0,1-.762-.762V416.113a.762.762,0,0,1,.762-.762h1.625a.762.762,0,0,1,.762.762Zm4.571-22.191H696v3.148h-9.141Zm12.188,20.668a.762.762,0,0,1-.762.762H683.811V416.875h14.472a.762.762,0,0,1,.762.762Z",
    transform: "translate(-674.568 -410.679)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.761 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.48,422.929h-1.523a.762.762,0,1,0-.008,1.524h1.532a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-681.19 -422.929)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.338 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.29,422.929h-1.524a.762.762,0,0,0,0,1.524h1.524a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-684.007 -422.929)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.91 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.1,422.929h-1.523a.762.762,0,0,0,0,1.524H689.1a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-686.82 -422.929)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.769 16.859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.477,421.054h-1.523a.762.762,0,0,0,0,1.524h1.524a.762.762,0,0,0,0-1.524Z",
    transform: "translate(-681.195 -421.054)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.338 16.859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.29,421.054h-1.524a.762.762,0,0,0,0,1.524h1.524a.762.762,0,0,0,0-1.524Z",
    transform: "translate(-684.007 -421.054)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.91 16.859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.1,421.054h-1.523a.762.762,0,0,0,0,1.524H689.1a.762.762,0,0,0,0-1.524Z",
    transform: "translate(-686.82 -421.054)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.761 13.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.48,419.179h-1.523a.762.762,0,1,0-.008,1.524h1.532a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-681.19 -419.179)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.338 13.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.29,419.179h-1.524a.762.762,0,0,0,0,1.524h1.524a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-684.007 -419.179)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.91 13.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.1,419.179h-1.523a.762.762,0,0,0,0,1.524H689.1a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-686.82 -419.179)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.766 7.719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.618,415.429H681.955a.762.762,0,0,0-.762.762v3.047a.762.762,0,0,0,.762.762H692.62a.762.762,0,0,0,.762-.762v-3.047a.762.762,0,0,0-.762-.762Zm-.762,3.047h-9.141v-1.523h9.141Z",
    transform: "translate(-681.193 -415.429)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.e616aaffc0aaa0d6b7b2e0fa4f9b602a.svg";
export { ForwardRef as ReactComponent };